import { useEffect, useRef, useState } from "react";
import { AudioLines, Upload } from "lucide-react";
import { api } from "@/lib/api";

export default function SystemAudios() {
  const [item, setItem] = useState(null);
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const inputRef = useRef(null);

  const load = async () => {
    const { data } = await api.get("/system-audios");
    setItem(data[0] || null);
  };

  useEffect(() => { load().catch(() => setError("Não foi possível carregar os áudios.")); }, []);

  const upload = async () => {
    if (!file || !item) return;
    setBusy(true); setMessage(""); setError("");
    try {
      const body = new FormData();
      body.append("file", file);
      await api.post(`/system-audios/${item.id}`, body, { headers: { "Content-Type": "multipart/form-data" } });
      await load();
      setFile(null);
      if (inputRef.current) inputRef.current.value = "";
      setMessage("Áudio atualizado. A nova mensagem já está ativa.");
    } catch (e) {
      setError(e.response?.data?.detail || "Não foi possível enviar o áudio.");
    } finally { setBusy(false); }
  };

  return (
    <div className="space-y-5" data-testid="system-audios-page">
      <div>
        <div className="text-[10px] uppercase tracking-widest text-[color:var(--text-muted)]">Mensagens operacionais</div>
        <h1 className="text-2xl font-semibold tracking-tight">Áudios do sistema</h1>
      </div>

      {message && <div className="text-xs text-[color:var(--accent-green)] font-mono">{message}</div>}
      {error && <div className="text-xs text-[color:var(--accent-red)] font-mono">{error}</div>}

      <div className="sbc-card p-5 max-w-3xl">
        <div className="flex items-start gap-3 mb-5">
          <div className="w-9 h-9 border border-[color:var(--border-default)] flex items-center justify-center text-[color:var(--accent-blue)]">
            <AudioLines size={18} />
          </div>
          <div>
            <h2 className="text-sm font-semibold">{item?.nome || "Serviço não habilitado"}</h2>
            <p className="text-xs text-[color:var(--text-secondary)] mt-1">{item?.descricao}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5 text-xs">
          <div><div className="text-[10px] uppercase tracking-widest text-[color:var(--text-muted)] mb-1">Arquivo atual</div><div className="font-mono break-all">{item?.filename || "-"}</div></div>
          <div><div className="text-[10px] uppercase tracking-widest text-[color:var(--text-muted)] mb-1">Última alteração</div><div>{item?.updated_at ? new Date(item.updated_at).toLocaleString("pt-BR") : "Áudio padrão"}</div></div>
        </div>

        <label className="block text-[10px] uppercase tracking-widest text-[color:var(--text-muted)] mb-2" htmlFor="system-audio-file">Novo áudio WAV ou MP3</label>
        <input ref={inputRef} id="system-audio-file" type="file" accept=".wav,.wave,.mp3,audio/wav,audio/mpeg" onChange={(e) => setFile(e.target.files?.[0] || null)} className="sbc-input w-full mb-3" />
        <div className="flex items-center justify-between gap-3">
          <span className="text-[11px] text-[color:var(--text-muted)]">Máximo 25 MB. O arquivo será convertido automaticamente para telefonia.</span>
          <button className="sbc-btn sbc-btn-primary shrink-0" onClick={upload} disabled={!file || busy} data-testid="upload-system-audio">
            <Upload size={14} />{busy ? "Convertendo..." : "Enviar e ativar"}
          </button>
        </div>
      </div>
    </div>
  );
}
